//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from '~/components/Pagination.vue';
import constant from '~/const';
import Filters from './ApiKeysFilters.vue';
import User from '~/components/User.vue';
import ApiKeysModal from './ApiKeysModal.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    Pagination,
    ApiKeysModal,
    User,
  },

  data() {
    return {
      tableConfig,
      updatingApiKey: {
        modal: false,
        input: {},
      },
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('apiKeys', ['page', 'pages', 'data']),

    getClaimsList() {
      return this.$utils.getAppType() === 'p2pay' ? constant.api.P2PAY_CLIENT_CLAIM_TYPE_LIST : constant.api.CLIENT_CLAIM_TYPE_LIST;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('apiKeys', {
      loadDataAction: 'loadData',
      updateApiKeyAction: 'updateApiKey',
      setPageAction: 'setPage',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      try {
        await this.loadDataAction(data);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    async updateApiKey({ input }) {
      const {
        appName,
        active,
        claimList,
        id,
      } = input;

      const data = {
        keyId: id,
        appName,
        active,
        claimList,
      };

      this.setGeneralProgress(true);
      try {
        await this.updateApiKeyAction(data);
        await this.loadDataAction({});
        this.updatingApiKey.modal = false;
        this.setSuccessNotification('API key updated');
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },

    getPermissionList(list) {
      const filteredList = this.getClaimsList.filter((e) => list.includes(e.id));
      const permissionList = filteredList.map((e) => this.$t(`const.${e.caption}`));
      return permissionList.join(', ');
    },

    change(row) {
      this.updatingApiKey.input.appName = row.appName;
      this.updatingApiKey.input.active = row.active;
      this.updatingApiKey.input.claimList = row.permissionList;
      this.updatingApiKey.input.id = row.id;
      this.updatingApiKey.modal = true;
    },
  },
};
